import { Component, Output, Input, EventEmitter, computed } from '@angular/core';

import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { ShopService } from '@app/services/shops/shop.service';
import { DeliverCursorPaginationService } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.service';
import { TABLES } from '@utils/table.utils';

@Component({
  selector: 'preview-action-container',
  templateUrl: '../action-container/action-container.component.html',
  styleUrls: ['../action-container/action-container.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 0 })),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        group([animate(300, style({ height: 0 })), animate('200ms ease-in-out', style({ opacity: '0' }))]),
      ]),
      transition(':enter', [
        style({ height: '0', opacity: 0 }),
        group([animate(300, style({ height: '*' })), animate('400ms ease-in-out', style({ opacity: '1' }))]),
      ]),
    ]),
  ],
  standalone: false,
})
export class ActionContainerComponent {
  @Input() assignLoader: boolean;
  @Input() selectedValidOrders: [];
  @Input() countValidatedOrders: number;
  @Input() isBottomScrolled: boolean;
  @Input() isOrdersUpdating: boolean;
  @Output() onSendOrdersToAssign = new EventEmitter<void>();

  isHideAssignButton = false;

  isCapped = computed(() => {
    const metadata = this.shopService.metadataSignal();
    const isUsingCursorPagination = DeliverCursorPaginationService.isCursorPaginationEnabled(metadata, TABLES.VERIFY);
    const cap = DeliverCursorPaginationService.getShopCap(metadata, TABLES.VERIFY);
    return isUsingCursorPagination && this.countValidatedOrders >= cap;
  });

  constructor(private shopService: ShopService) {}

  toggleAssignButton(): void {
    this.isHideAssignButton = !this.isHideAssignButton;
  }

  sendOrders() {
    this.onSendOrdersToAssign.emit();
  }
}
